module.exports = __webpack_public_path__ + "img/agreement.7539830d.jpg";